import { getFromDTonomyAPI } from "./common";
/**
 * API call to the DTonomy plugin backend service
 * Parses to JSON object if 200 response code returned
 * else we assume that the ip was invalid
 * @param {String} email The ip address to submit to the geoip api.
 * @returns {Object}
 * {
 *    domain: "dtonomy.com",
 *    sendPhishingReportToEmail: "info@dtonomy.com"
 *    subscription:
 *        isPaid: true,
 *        status: "PAID"
 * }
 */
export async function getUserSetting(email){
      let response =  await getFromDTonomyAPI("domain_settings/Outlook/"+email);
      if(response.status == 200){
            const data = response.json();
            return data; 
          }
      else{
           return {
                 error: "user profile check failure"
           } 
      }
}

const openContactDtonomyForm = () => {
      const emails = ["support@dtonomy.com"];
      const subject = "Outlook Phish AIR Professional Subscription";
      const userName = Office.context.mailbox.userProfile.displayName || Office.context.mailbox.userProfile.emailAddress;
      const htmlBody = (`
          <p>I would like to subscribe to Phish AIR Professional. Please let me know how to proceed. </p>
          <br>
          `
      );

      Office.context.mailbox.displayNewMessageForm({
        toRecipients: emails,
        subject: subject,
        htmlBody: htmlBody
      });
    }


export function contactDtonomy(event) {
      event.preventDefault();
      openContactDtonomyForm();
}

export async function isPaiedUser(userEmail) {
      let isPaid = false;
      let result = await getUserSetting(userEmail);
      if (result.domain) {
        if (result.subscription.isPaid) {
          isPaid = true;
        }
      }
      return isPaid;   
}